export default "__VITE_ASSET__DTBhFq2C__"